<template>
  <v-card class="vpd-panel vpd-resetpass-panel">
    <vpd-card-title title="Elfelejtett jelszó" has-back-button></vpd-card-title>

    <v-alert
      v-model="alert"
      :type="alertType"
      close-text="Bezárás"
      dismissible
      @click="alert = false"
    >
      {{ alertMessage }}
    </v-alert>

    <v-row justify="center">
      <v-col align="center" class="subtitle-1 fix-width">
        A jelszó visszaállításához kérjük vegye fel a kapcsolatot az
        ügyfélszolgálattal a
        <a
          href="mailto:kerdes@bankszamlakivonat.hu"
          class="email-link"
        >
          kerdes@bankszamlakivonat.hu
        </a>
        email címen.
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import "./_vpd-resetpass-panel.scss";
import VpdCardTitle from "@/components/vpd-card-title/vpd-card-title";

export default {
  name: "vpd-resetpass-panel",
  components: { VpdCardTitle },
  props: {},
  data: () => ({
    alert: false,
    alertMessage: "",
    alertType: "error",
    email: "",
    valid: false,
    emailRules: [
      (v) => !!v || "Az email cím kötelező",
      (v) => /.+@.+/.test(v) || "Érvénytelen email",
    ],
  }),
  methods: {
    resetPass() {
      //TODO remove this.$refs
      if (this.$refs.form.validate()) {
        this.$emit("submit", this.email);
      }
    },
    showAlert(msg, type) {
      this.alertMessage = msg;
      this.alertType = type;
      this.alert = true;
    },
  },
};
</script>
